ceregoCommon.factory('MyMailersResource', ['$resource', ($resource) ->
  $resource "", {},
    sendMobileLoginInfo:
      method: 'POST'
      isArray: false
      url: APIRoutes.mobile_login_info_v2_my_mailers_path()
])
